import React from "react";
import { useIntl } from "@ai360/core/intl";

import { toCropDropdownOptions, useCropList } from "~/admin/setup/customer/use-crop-list";
import {
    computeIsSelectable,
    useLoggedInUserProductScopeOrgLevelGuid,
} from "~/admin/setup/customer/use-product-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, dropdowns, service, model } from "./../data";
import { messages as globalMessages } from "~/i18n-messages";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    dropdowns,
    service,
});

// prepareSelectableOptions (admin/utils.ts) only carries a source item's own `isSelectable`/
// `getToolTip` through into `value` -- stamp both here so the crop SelectInput downstream can key
// optionIsHiddenKey off IS_SELECTABLE and show a per-option tooltip on an unlinked crop.
const toSelectableCropDropdownOptions = (crops, formatMessage) =>
    toCropDropdownOptions(crops).map((crop) => ({
        ...crop,
        isSelectable: computeIsSelectable(crop.activeYn, crop.isAgvanceLinked),
        ...(crop.isAgvanceLinked === false && {
            getToolTip: () => formatMessage(globalMessages.cropNotLinkedInAgvance),
        }),
    }));

const AddEditContainer = (props) => {
    const { formatMessage } = useIntl();
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{ [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops, formatMessage) }}
        />
    );
};

export default AddEditContainer;
